import {
  IonGrid,
  IonRow,
  IonCol,
  IonList,
  IonListHeader,
  IonLabel,
  IonItem,
  IonImg,
} from '@ionic/react';
import React from 'react';
import { NavLink } from 'react-router-dom';
import { connect } from 'react-redux';

import {
  FOOTER_LISTS,
  SPORTS_FOOTER_LISTS,
  CASINO_FOOTER_LISTS,
} from '../../constants/FooterView';
import { CONFIG_PERMISSIONS } from '../../constants/ConfigPermission';
import './Footer.scss';
import { RootState } from '../../models/RootState';
import SocialMedia from '../SocialMedia/SocialMedia';
import Copyright from '../Copyright/Copyright';
import titleImg from '../../assets/images/brand/title.png';
import betfairImg from '../../assets/images/footer/betfair.svg';

type StoreProps = {
  allowedConfig: number;
};

const Footer: React.FC<StoreProps> = (props) => {
  const { allowedConfig } = props;

  return (
    <IonGrid class="footer-grid">
      <IonRow class="footer-title-row">
        <IonCol className="tab-view">
          <IonLabel class="footer-title">
            {/* <IonImg src={titleImg} /> */}
            Get connected with us on social networks:
          </IonLabel>
        </IonCol>
        {/* <IonCol size="12" className="mob-view">
          <IonLabel class="betfair-title">
            <IonImg src={betfairImg} />
          </IonLabel>
        </IonCol> */}
        <IonCol className="web-social-media-group">
          <SocialMedia></SocialMedia>
        </IonCol>
      </IonRow>
      {/* <IonRow class="footer-lists">
        {(allowedConfig & CONFIG_PERMISSIONS.sports) !== 0 ? (
          <>
            {SPORTS_FOOTER_LISTS.map((item, i) => (
              <IonCol
                sizeXs="5"
                sizeSm="5"
                sizeMd="2"
                sizeLg="2"
                key={item.name}
              >
                <IonListHeader class="footer-list-header">
                  {item.name}
                </IonListHeader>

                <IonList class="footer-list">
                  {item.items.map((listItem, i) => (
                    <>
                      {allowedConfig & listItem.id ? (
                        <IonItem lines="none" key={i} class="footer-list-item">
                          <NavLink to={listItem.url} className="nav-link-text">
                            {listItem.name}
                          </NavLink>
                        </IonItem>
                      ) : null}
                    </>
                  ))}
                </IonList>
              </IonCol>
            ))}{' '}
          </>
        ) : null}

        {(allowedConfig & CONFIG_PERMISSIONS.live_casino) !== 0 ? (
          <>
            {CASINO_FOOTER_LISTS.map((item, i) => (
              <IonCol
                sizeXs="5"
                sizeSm="5"
                sizeMd="2"
                sizeLg="2"
                key={item.name}
              >
                <IonListHeader class="footer-list-header">
                  {item.name}
                </IonListHeader>

                <IonList class="footer-list">
                  {item.items.map((listItem, i) => (
                    <IonItem lines="none" key={i} class="footer-list-item">
                      <NavLink to={listItem.url} className="nav-link-text">
                        {listItem.name}
                      </NavLink>
                    </IonItem>
                  ))}
                </IonList>
              </IonCol>
            ))}{' '}
          </>
        ) : null}

        {FOOTER_LISTS.map((item, i) => (
          <IonCol sizeXs="5" sizeSm="5" sizeMd="2" sizeLg="2" key={item.name}>
            <IonListHeader class="footer-list-header">
              {item.name}
            </IonListHeader>

            <IonList class="footer-list">
              {item.items.map((listItem, i) => (
                <IonItem lines="none" key={i} class="footer-list-item">
                  <NavLink to={listItem.url} className="nav-link-text">
                    {listItem.name}
                  </NavLink>
                </IonItem>
              ))}
            </IonList>
          </IonCol>
        ))}
      </IonRow> */}
      <IonRow class="mobile-social-media-group">
        {/* <SocialMedia></SocialMedia> */}
      </IonRow>
      <Copyright></Copyright>
    </IonGrid>
  );
};

const mapStateToProps = (state: RootState) => {
  return {
    allowedConfig: state.common.allowedConfig,
  };
};

export default connect(mapStateToProps, null)(Footer);
